import { useCallback } from 'react'

export const useScroll = () => {
	const scrollIntoBlock = useCallback((selector: string) => {
		document.querySelector(selector)?.scrollIntoView({ behavior: 'smooth' })
	}, [])

	return { scrollIntoBlock }
}
